import { Step, StepLabel, Stepper } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface RegistrationStepperProps {
  activeStep: number
}

export const RegistrationStepper = ({ activeStep }: RegistrationStepperProps) => {
  const { t } = useTranslation('registrationStepper')
  const steps = [t('email'), t('verifyEmail'), t('finalize')]
  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map(label => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
